import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUser, BUSINESS_UNIT_EMAIL_CONTACT_TYPE, BUSINESS_UNIT_METADATA, BUSINESS_UNIT_TYPE, BusinessUnit, BusinessUnitEmailContact, RefCode } from 'assets-model';
import { BusinessUnitEmailContactDataSource, BusinessUnitEmailContactService, BusinessUnitService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class BusinessUnitEmailContactSearchComponentBase extends CrudListComponent<BusinessUnitEmailContact, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'businessUnitEmailContactId', 'businessUnit.buId', 'addrType', 'createdBy', 'createdDate', 'description', 'email', 'lockVersion', 'updatedBy', 'updatedDate', 'actions'];

  public searchForm: FormGroup;

  businessUnitEmailContactIdFilter: number;
  @ViewChild('businessUnitEmailContactIdFilterInput') businessUnitEmailContactIdFilterInput: ElementRef;

  businessUnitFilter: BusinessUnit;
  businessUnitSelectionList: BusinessUnit[];
  @ViewChild('businessUnitFilterInput') businessUnitFilterInput: MatSelect;

  addrTypeSelectionList: RefCode[];
  addrTypeFilter: string;
  @ViewChild('addrTypeFilterInput') addrTypeFilterInput: MatSelect;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  descriptionFilter: string;
  @ViewChild('descriptionFilterInput') descriptionFilterInput: ElementRef;

  emailFilter: string;
  @ViewChild('emailFilterInput') emailFilterInput: ElementRef;

  updatedByFilter: string;
  @ViewChild('updatedByFilterInput') updatedByFilterInput: ElementRef;

  updatedDateFilter: Date;
  @ViewChild('updatedDateFilterInput') updatedDateFilterInput: ElementRef;
  updatedDateLessThanFilter: Date;
  @ViewChild('updatedDateLessThanFilterInput') updatedDateLessThanFilterInput: ElementRef;
  updatedDateLessThanOrEqualToFilter: Date;
  @ViewChild('updatedDateLessThanOrEqualToFilterInput') updatedDateLessThanOrEqualToFilterInput: ElementRef;
  updatedDateGreaterThanFilter: Date;
  @ViewChild('updatedDateGreaterThanFilterInput') updatedDateGreaterThanFilterInput: ElementRef;
  updatedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('updatedDateGreaterThanOrEqualToFilterInput') updatedDateGreaterThanOrEqualToFilterInput: ElementRef;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected businessUnitEmailContactService: BusinessUnitEmailContactService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(BUSINESS_UNIT_EMAIL_CONTACT_TYPE, route, router, userStorage, dialog, businessUnitEmailContactService, injector);

    this.searchForm = this.fb.group({
      businessUnitEmailContactId: [null],
      businessUnit: [null],
      addrType: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      description: [null],
      email: [null],
      updatedBy: [null],
      updatedDateLessThan: [null],
      updatedDateLessThanOrEqualTo: [null],
      updatedDateGreaterThan: [null],
      updatedDateGreaterThanOrEqualTo: [null],
      updatedDate: [null]
    });
  }

  createDataSource(): CrudDataSource<BusinessUnitEmailContact> {
    return new BusinessUnitEmailContactDataSource(this.businessUnitEmailContactService);
  }

  createServiceArguments(): any {
    return {
      businessUnitEmailContactId: this.businessUnitEmailContactIdFilter,
      buId: this.businessUnitFilter && this.businessUnitFilter.buId,
      addrType: this.addrTypeFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      description: this.descriptionFilter,
      email: this.emailFilter,
      updatedBy: this.updatedByFilter,
      updatedDateLessThan: this.updatedDateLessThanFilter,
      updatedDateLessThanOrEqualTo: this.updatedDateLessThanOrEqualToFilter,
      updatedDateGreaterThan: this.updatedDateGreaterThanFilter,
      updatedDateGreaterThanOrEqualTo: this.updatedDateGreaterThanOrEqualToFilter,
      updatedDate: this.updatedDateFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.businessUnitEmailContactIdFilter = null;
    this.businessUnitFilter = null;
    this.addrTypeFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.descriptionFilter = null;
    this.emailFilter = null;
    this.updatedByFilter = null;
    this.updatedDateLessThanFilter = null;
    this.updatedDateLessThanOrEqualToFilter = null;
    this.updatedDateGreaterThanFilter = null;
    this.updatedDateGreaterThanOrEqualToFilter = null;
    this.updatedDateFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.businessUnitEmailContactIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.businessUnitFilterInput);
    this.addSearchOnChangedSelectEventListener(this.addrTypeFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.descriptionFilterInput);
    this.addSearchOnChangedInputEventListener(this.emailFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      businessUnitEmailContactId: (value: number) => self.businessUnitEmailContactIdFilter = value,
      businessUnit: (value: BusinessUnit) => { self.businessUnitFilter = value; this.businessUnitChanged(value, false); },
      addrType: (value: string) => self.addrTypeFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      description: (value: string) => self.descriptionFilter = value,
      email: (value: string) => self.emailFilter = value,
      updatedBy: (value: string) => self.updatedByFilter = value,
      updatedDateLessThan: (value: Date) => self.updatedDateLessThanFilter = value,
      updatedDateLessThanOrEqualTo: (value: Date) => self.updatedDateLessThanOrEqualToFilter = value,
      updatedDateGreaterThan: (value: Date) => self.updatedDateGreaterThanFilter = value,
      updatedDateGreaterThanOrEqualTo: (value: Date) => self.updatedDateGreaterThanOrEqualToFilter = value,
      updatedDate: (value: Date) => self.updatedDateFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  businessUnitEmailContactIdChanging(value: number, unsetDependents: boolean = true) {}
  
  businessUnitEmailContactIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll().subscribe(
      data => {
        this.businessUnitSelectionList = data.items;
      }
    );
  }
  
  businessUnitDisplay(item: BusinessUnit) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return BUSINESS_UNIT_TYPE.description(item);
  }
  
  businessUnitChanging(value: BusinessUnit, unsetDependents: boolean = true) {}
  
  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  businessUnitCompare(a: any, b: any) {
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }
  
  

  addrTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('BU_ADDR_TYPE').subscribe(
      data => {
        this.addrTypeSelectionList = data;
      }
    );
  }

  addrTypeChanging(value: string, unsetDependents: boolean = true) {}
  
  addrTypeChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  descriptionChanging(value: string, unsetDependents: boolean = true) {}
  
  descriptionChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  emailChanging(value: string, unsetDependents: boolean = true) {}
  
  emailChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get businessUnitEmailContactId() {
    return this.searchForm && this.searchForm.get('businessUnitEmailContactId');
  }

  get businessUnit() {
    return this.searchForm && this.searchForm.get('businessUnit');
  }

  get addrType() {
    return this.searchForm && this.searchForm.get('addrType');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get description() {
    return this.searchForm && this.searchForm.get('description');
  }

  get email() {
    return this.searchForm && this.searchForm.get('email');
  }

  get updatedBy() {
    return this.searchForm && this.searchForm.get('updatedBy');
  }

  get updatedDate() {
    return this.searchForm && this.searchForm.get('updatedDate');
  }

  get updatedDateLessThan() {
    return this.searchForm && this.searchForm.get('updatedDateLessThan');
  }
  
  get updatedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateLessThanOrEqualTo');
  }
  
  get updatedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThan');
  }
  
  get updatedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThanOrEqualTo');
  }


}



